import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';

const AddCustomerButton = () => {
	return (
		<section>
			<Link to='/add'>
				<button>
					<FontAwesomeIcon icon={faUserPlus} /> Lägg till kund
				</button>
			</Link>
		</section>
	);
};

export default AddCustomerButton;
